var map = {
	"./en.json": [
		96082,
		6082
	],
	"./id.json": [
		44868,
		4868
	],
	"./php_en.json": [
		55703,
		5703
	],
	"./php_id.json": [
		4077,
		4077
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25852;
module.exports = webpackAsyncContext;